export const removeLastSlash = (text: string) => {
  let finalText = text
  if (text !== "/" && text.substr(text.length - 1) === "/") {
    finalText = text.substr(0, text.length - 1)
  }
  return finalText
}
